import React from 'react';

const CancelSubscriptionModal = ({ subscription, actionLoading, onCancel, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold text-orange-600 mb-4">Cancel Subscription</h3>
        <p className="text-gray-600 mb-4">
          Are you sure you want to cancel the subscription for <strong>{subscription.customer_name || subscription.customerName}</strong>?
        </p>
        <p className="text-sm text-orange-500 mb-4">
          Info: This will mark the subscription as cancelled but keep the data for records.
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
            disabled={actionLoading}
          >
            Keep Active
          </button>
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-orange-600 text-white rounded hover:bg-orange-700 disabled:opacity-50"
            disabled={actionLoading}
          >
            {actionLoading ? 'Cancelling...' : 'Cancel Subscription'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelSubscriptionModal;